import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { LISTINGS_PER_PAGE, useSearchResultsQuery } from './useSearchResultsQuery';
export function useSearchResultsPagination() {
  var _data$result$total;
  const params = useSearchParams();
  const {
    data
  } = useSearchResultsQuery();
  const currentPage = Number(params.get('page')) || 1;
  const totalResults = (_data$result$total = data === null || data === void 0 ? void 0 : data.result.total) !== null && _data$result$total !== void 0 ? _data$result$total : 0;
  const pageCount = Math.max(1, Math.ceil(totalResults / LISTINGS_PER_PAGE));
  return {
    currentPage,
    pageCount
  };
}